const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'No file chosen',
    fileName: 'File Name',
    software_service: 'Software Service',
    hardware_product: 'Hardware Product',
    sampleFileNameUS: 'Merchandise Credit US',
    sampleFileNameAU: 'Merchandise Credit AU',
    sampleFileNameNL: 'Merchandise Credit NL',
    sampleFileNameBE: 'Merchandise Credit BE',
    sampleFileNameMX: 'Merchandise Credit MX',
    sampleFileNameFR: 'Merchandise Credit FR',
    rowNumber: 'Row Number',
    errorMessage: 'Message'
  }
};

export default merchandiseCredit;
